import { Search, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface ClassSearchInputProps {
  value: string;
  onChange: (next: string) => void;
  className?: string;
}

/** The "lupa": keyword search over the student's classes, styled like the filter pills. */
export function ClassSearchInput({ value, onChange, className }: ClassSearchInputProps) {
  const { t } = useTranslation('admin');

  return (
    <label
      className={
        'relative inline-flex w-full min-w-[14rem] items-center rounded-full sm:w-auto border border-rose-200 bg-white pl-3 pr-2 shadow-[inset_0_1px_0_rgba(255,255,255,0.8),0_2px_0_rgba(0,0,0,0.04),0_4px_8px_rgba(247,141,167,0.08)] focus-within:ring-2 focus-within:ring-rose-300 ' +
        (className ?? '')
      }
    >
      <Search aria-hidden="true" className="h-4 w-4 shrink-0 text-[#cf2e2e]" />
      <input
        type="search"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={t('p2e.classes.page.search.placeholder')}
        aria-label={t('p2e.classes.page.search.placeholder')}
        className="w-full bg-transparent px-2 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 outline-none [&::-webkit-search-cancel-button]:hidden"
      />
      {value && (
        <button
          type="button"
          onClick={() => onChange('')}
          aria-label={t('p2e.classes.page.search.clear')}
          className="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-gray-500 hover:bg-rose-50 hover:text-[#cf2e2e]"
        >
          <X aria-hidden="true" className="h-3.5 w-3.5" />
        </button>
      )}
    </label>
  );
}
